import { render, staticRenderFns } from "./teachCompre.vue?vue&type=template&id=4eeefb48&scoped=true"
import script from "./teachCompre.vue?vue&type=script&lang=js"
export * from "./teachCompre.vue?vue&type=script&lang=js"
import style0 from "./teachCompre.vue?vue&type=style&index=0&id=4eeefb48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eeefb48",
  null
  
)

export default component.exports